import { Components, Theme } from "@mui/material"

export const MuiAccordion: Components<Theme>["MuiAccordion"] = {
  styleOverrides: {
    root: () => ({
      padding: 0,
      borderTopLeftRadius: "8px !important",
      borderTopRightRadius: "8px !important",
      borderBottomLeftRadius: "8px !important",
      borderBottomRightRadius: "8px !important",
      overflow: "hidden",
      marginBottom: "0 !important",
      marginTop: "0 !important",
      boxShadow: "unset",
    }),
  },
}
